export default __webpack_public_path__ + "static/media/68.e8923d63.jpg";